import { useState, useEffect } from 'react';

export const API = `${window.location.origin}/api`;

const DEFAULTS = { app_name: 'CCBRJM', subtitle: 'Gestão de jovens e crianças.', terms_of_use: '' };

export function useSettings() {
  const [settings, setSettings] = useState(DEFAULTS);

  const fetchSettings = async () => {
    try {
      const r = await fetch(`${API}/settings`);
      if (r.ok) {
        const data = await r.json();
        setSettings({ ...DEFAULTS, ...data });
        document.title = data.app_name || DEFAULTS.app_name;
      }
    } catch {}
  };

  useEffect(() => { fetchSettings(); }, []);

  return { settings, refreshSettings: fetchSettings };
}
